/** @jsxImportSource @emotion/react */
import React from 'react'
import { StaffForm, StaffPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/StaffContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, staffManagement } = breadcrumbItems

const StaffCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <StaffForm />
        </div>
        <div css={styles.right}>
          <StaffPreview />
        </div>
      </div>
    </Provider>
  )
}

export default StaffCreate;
